import { style, styleVariants } from '@vanilla-extract/css';
import { clickableClass, LinkVariant, themeVars } from '@tundr/theme';
import { LinkSize } from './Link.types';

export const linkContainerClass = style({
  display: 'flex',
  alignItems: 'center',
});

export const linkClass = style([
  clickableClass,
  {
    transition: themeVars.transitions.fast,
    display: 'inline',
    cursor: 'pointer',
  },
]);

export const linkArrowClass = style({
  fontSize: themeVars.font.size.iconLg,
  position: 'relative',
});

export const linkVariants = styleVariants({
  [LinkVariant.primary]: [
    linkClass,
    {
      color: themeVars.colors.components.link[LinkVariant.primary].default,

      ':hover': {
        color: themeVars.colors.components.link[LinkVariant.primary].hover,
      },
    },
  ],
  [LinkVariant.external]: [
    linkClass,
    {
      color: themeVars.colors.components.link[LinkVariant.external].default,

      ':hover': {
        color: themeVars.colors.components.link[LinkVariant.external].hover,
      },
    },
  ],
});

export const linkTextVariants = styleVariants({
  [LinkVariant.primary]: {
    textDecoration: 'underline',
  },
  [LinkVariant.external]: {
    textDecoration: 'none',
  },
});

export const linkSizeVariants = styleVariants({
  [LinkSize.default]: {
    fontSize: themeVars.font.size.textSm,
  },
  [LinkSize.md]: {
    fontSize: themeVars.font.size.textMd,
  },
});
